"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var __1 = tslib_1.__importDefault(require("../.."));
var toLccc_1 = require("../../util/toLccc");
var TypedObjectAccessor_1 = tslib_1.__importDefault(require("./TypedObjectAccessor"));
var SSPBaseDataAccessor = (function () {
    function SSPBaseDataAccessor(rawModel) {
        this._lccc = null;
        this._acc = new TypedObjectAccessor_1.default();
        this.update(rawModel);
    }
    SSPBaseDataAccessor.prototype.update = function (rawModel) {
        this._acc.target = rawModel;
    };
    SSPBaseDataAccessor.prototype.setLanguage = function (lcOrLccc, cc) {
        if (cc === void 0) { cc = null; }
        this._lccc = toLccc_1.toLccc(lcOrLccc, cc);
    };
    SSPBaseDataAccessor.prototype.getLanguage = function () {
        if (!this._lccc) {
            return __1.default.instance.getCurrentLanguage();
        }
        return this._lccc;
    };
    Object.defineProperty(SSPBaseDataAccessor.prototype, "uid", {
        get: function () {
            return this._acc.str('Uid');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "version", {
        get: function () {
            return this._acc.integer('Version');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "name", {
        get: function () {
            return this._acc.str('Name');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "contentType", {
        get: function () {
            return this._acc.str('ContentType');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "contentTypeVersion", {
        get: function () {
            return this._acc.integer('ContentTypeVersion');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "contentJsonVersion", {
        get: function () {
            return this._acc.integer('ContentJsonVersion');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "contentTypeName", {
        get: function () {
            var lc = toLccc_1.toLc(this.getLanguage());
            var names = this._acc.obj('ContentTypeName');
            var nameLc = null;
            for (nameLc in names) {
                if (nameLc === lc) {
                    return names[nameLc];
                }
            }
            if (nameLc && names[nameLc]) {
                return names[nameLc];
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "vfsParent", {
        get: function () {
            return this._acc.ref('VfsParent');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "publishingState", {
        get: function () {
            return this._acc.str('PublishingState');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "publishingStateChangeTime", {
        get: function () {
            return this._acc.w3cddate('PublishStateChangeTime');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "publishingMessage", {
        get: function () {
            return this._acc.str('PublishingMessage');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "modifiedTime", {
        get: function () {
            return this._acc.w3cddate('ModifiedTime');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "createdTime", {
        get: function () {
            return this._acc.w3cddate('CreatedTime');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "languages", {
        get: function () {
            return this._acc.strlist('Languages');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "isFolder", {
        get: function () {
            return this.contentType === 'folder';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "isAsset", {
        get: function () {
            var assetDataSet = this._acc.obj('AssetDataSet');
            return !!assetDataSet && 'AssetFileFamily' in assetDataSet && assetDataSet.AssetFileFamily;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "isModel", {
        get: function () {
            return !this.isFolder && !this.isAsset;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SSPBaseDataAccessor.prototype, "isMultilingual", {
        get: function () {
            return this.languages.length > 1;
        },
        enumerable: false,
        configurable: true
    });
    SSPBaseDataAccessor.prototype.hasLanguage = function (lcOrLccc, cc) {
        if (cc === void 0) { cc = null; }
        return this.languages.indexOf(toLccc_1.toLccc(lcOrLccc, cc)) >= 0;
    };
    return SSPBaseDataAccessor;
}());
exports.default = SSPBaseDataAccessor;
